import $ from 'jquery'
import Vue from 'vue'

import {
  setUserSessio
} from './UserStorage.js'

//加载首页事件
//加载
// export function Logins() {
// }
// $(document).ready(function() {

//   $("#btnSendCode1").on("click", function() {
//     sendMessage1();
//   });

  var phoneReg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/; //手机号正则
  var count = 60; //间隔函数，1秒执行
  var InterValObj1; //timer变量，控制时间
  var curCount1; //当前剩余秒数
  /*第一*/
  export function sendMessage1() {
    // console.log("--------------",window.login.validateForm.username);
    if (window.login.validateForm.username.length < 3) {
      window.login.$message.error('Please enter the correct email address');
      return;
    }
    //定义一个请求参数的对象，通过结构表达式来获取brand当中的属性
    let params = new URLSearchParams();
    params.append('mail', window.login.validateForm.username);
    Vue.prototype.$http.post('/user/SendCode', params)
      .then(function(response) {
        console.log(response.data);
        if (response.data.success || response.data.code == 1) {
          window.login.$message(response.data.message);
        } else {
          window.login.$message.error(response.data.message);
        }
      })
      .catch(function(error) {
        console.log(error);
      });

    // Vue.prototype.$http.get('/user/SendCode', {
    //     params
    //   })
    //   .then(function(response) {
    //     console.log(response.data);
    //     // console.log("ShipINFOList:获取成功!");
    //     //  returnFun(response.data);
    //   })

    curCount1 = count;
    var phone = $.trim($('#phone1').val());
    // if (!phoneReg.test(phone)) {
    //   alert(" 请输入有效的手机号码");
    //   return false;
    // }
    //设置button效果，开始计时
    $("#btnSendCode1").attr("disabled", "true");
    // $("#btnSendCode1").val(+curCount1 + "Seconds to obtain");
      $("#btnSendCode1").text(curCount1);
    InterValObj1 = window.setInterval(SetRemainTime1, 1000); //启动计时器，1秒执行一次
    //向后台发送处理数据

  }

  function SetRemainTime1() {
    if (curCount1 == 0) {
      window.clearInterval(InterValObj1); //停止计时器
      $("#btnSendCode1").removeAttr("disabled"); //启用按钮
      // $("#btnSendCode1").val("To resend");

      $("#btnSendCode1").text("To resend");
    } else {
      curCount1--;
      // $("#btnSendCode1").text(+curCount1 + "Seconds to obtain");
      $("#btnSendCode1").text(curCount1);
    }
  }
// });


// /*提交*/
// function binding() {
//   alert(1)
// }

export function LoginAction(mail, verifyCode, returnFun) {
  if (mail < 3) {
    window.login.$message.error('Please enter the correct email address');
    return;
  } else if (verifyCode.length != 4) {
    window.login.$message.error('Error verification code');
    return;
  }

  let params = new URLSearchParams();
  params.append('mail', mail);
  params.append('verifyCode', verifyCode);
  Vue.prototype.$http.post('/user/Login', params)
    .then(function(response) {
      console.log(response.data);
      if (response.data.success || response.data.code == 1) {
        // window.login.$message(response.data.message);
        setUserSessio(response.data.content);
        returnFun();
        window.login.$message(response.data.message);
      } else {
        window.login.$message.error(response.data.message);
      }
    })
    .catch(function(error) {
      console.log(error);
    });
  // console.log("---------------");

  // $(document).ready(function() {
  //   $("#Login").on("click", function() {
  //     var pwds = $("#pass").val();
  //     if (pwds.length < 6) {
  //       alert("密码必须大于6位");
  //       return;
  //     }
  //     /*POST  */
  //     let params = new URLSearchParams();
  //     params.append('userAccount', $("#user").val());
  //     params.append('userPwd', md5(pwds));
  //     axios.post(Vue.prototype.Common.LoginURL, params)
  //       .then(function(response) {
  //         //console.log(response.data);
  //         if (response.data.success||response.data.code == 1) {
  //             // // window.location.href = "List/index.html";
  //             // setUserMessageCookies(json.content);
  //           //2021-11-04 更新:将用户数据存放至sessionstorage
  //           setUserSessio(response.data.content);

  //           console.log("登录成功");
  //           returnFun();
  //         } else {
  //           alert(response.data.message);

  //         }
  //       })
  //       .catch(function(error) {
  //         console.log(error);
  //       });

  //   });
  // });
}



// WEBPACK FOOTER //
// ./src/OK_Scott/assets/js/Login.js